import momentTZ from "moment-timezone";
import { DEFAULT_TIMEZONE } from "../constants";

// Every time a person reads on screen goes through here: the tenant's clock,
// with the zone abbreviation on the end so a Queensland row and a Victorian
// row can never be mistaken for each other. Accepts what the codebase stores:
// unix seconds, milliseconds, ISO strings (with the legacy space before the
// offset), Date objects, Firestore Timestamps and moments.
const toMoment = (input) => {
  if (input === null || input === undefined || input === "") return null;
  if (momentTZ.isMoment(input)) return input.clone();
  if (typeof input === "number") {
    // seconds before ~2286, milliseconds after
    return input < 1e11 ? momentTZ.unix(input) : momentTZ(input);
  }
  if (typeof input === "string") return momentTZ(input.replace(/\s+(?=[+-]\d{2}:?\d{2}$)/, ""));
  if (typeof input.toMillis === "function") return momentTZ(input.toMillis());
  if (input instanceof Date) return momentTZ(input);
  return momentTZ(input);
};

/**
 * Render an instant in the tenant zone with its abbreviation, e.g.
 * "15/10/2026 10:00 AEST". Returns "" for empty or invalid input.
 */
export const displayDateTime = (input, format = "DD/MM/YYYY HH:mm") => {
  const m = toMoment(input);
  if (!m || !m.isValid()) return "";
  const local = m.tz(DEFAULT_TIMEZONE);
  return `${local.format(format)} ${local.format("z")}`;
};

/** Unix seconds -> "YYYY-MM-DD HH:mm:ss AEST", the shape the log panels use. */
export const displayTimestamp = (unixSeconds, format = "YYYY-MM-DD HH:mm:ss") => displayDateTime(unixSeconds, format);
